
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { ErrorPageModel } from './state';

export const GoToStepAction = createAction('[member join] go to step', props<{ index: number }>());

export const NextStepAction = createAction('[member Join] move next step');

export const PreviousStepAction = createAction('[member Join] move previous step');

export const SetErrorPageDataAction = createAction('[member join] error page data',
  props<{ data: ErrorPageModel }>());

export const ErrorUpdatingAction = createAction('[member join] set error updating');

export const SignupCompletedAction = createAction('[member join] set sign up completed');